'use strict';

const _=require('pulsar-utils/dist-es6/_');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');

const SecretGuid=Guid.create().toString();
const SecretEmptyKey=`%%[[$$empty${SecretGuid}empty$$]]%%`;let

MultiValueAutocompleteDirective=class MultiValueAutocompleteDirective extends BaseControllerBackedDirective{
get templateUrl(){return'/templates/directives/multiValueAutocompleteDirective/multiValueAutocompleteTemplate'}

get objectBindings(){return['items','selectedItems','itemFormatter','autocompleteFilter']}

get $inject(){return['$scope','$element','$timeout']}

get controller(){return MultiValueAutocompleteController}};let


MultiValueAutocompleteController=class MultiValueAutocompleteController{
constructor($scope,$element,$timeout){
if(!_.exists(this.items)||!Array.isArray(this.items)||this.items.length<1){
throw new Error('controller.items must be an array containing at least one value to use autocomplete directive.');
}else if(!_.exists(this.selectedItems)||!Array.isArray(this.selectedItems)){
throw new Error('controller.selectedItems must be an array to use autocomplete directive.');
}else if(!_.exists(this.itemFormatter)||typeof this.itemFormatter!='function'){
throw new Error('controller.itemFormatter(item) must be a function to use autocomplete directive.');
}else if(!_.exists(this.autocompleteFilter)||typeof this.autocompleteFilter!='function'){
throw new Error('controller.itemFormatter(allItems, selectedItems) must be a function to use autocomplete directive.');
}

this._$scope=$scope;
this._inputElement=$element.find('input');
this._$timeout=$timeout;
this.currentItem=null;
this.selectedItems=[];
this.search=this.search.bind(this);

$scope.$watch('controller.items',newItems=>{
this.updateAvailableItems();
},!0);
$scope.$watch('controller.selectedItems',newSelectedItems=>{
this.updateAvailableItems();
},!0);

this._inputElement.
bind('focus',()=>this.showAllIfEmpty()).
bind('keyup',event=>{
if(event.originalEvent.keyIdentifier==='Up'||event.originalEvent.keyIdentifier==='Down')
return;

this.showAllIfEmpty();
});

this._$scope.$evalAsync(()=>{
this.updateAvailableItems();
});
}

showAllIfEmpty(){
this._$scope.$evalAsync(()=>{
if(this._inputElement.val().length<1){
this._inputElement.triggerHandler('input');
this._inputElement.val(SecretEmptyKey);
this._inputElement.triggerHandler('input');
this._inputElement.val('');
}else{
this.addItem();
}
});
}

search(item){
if(this._inputElement.val()===SecretEmptyKey){
return!0;
}

return this.itemFormatter(item).toLowerCase().indexOf(this._inputElement.val().toLowerCase())!==-1;
}

updateAvailableItems(){
this.availableItems=this.autocompleteFilter(this.items,this.selectedItems);
}

addItem(){
if(_.includes(this.availableItems,this.currentItem)&&_.includes(this.items,this.currentItem)){
this.selectedItems.push(this.currentItem);
this.updateAvailableItems();
this.currentItem=null;
}
}};


module.exports=MultiValueAutocompleteDirective;
//# sourceMappingURL=multiValueAutocompleteDirective.js.map
